import { useState } from 'react';
import axios from 'axios'; // Ensure axios is installed and imported
import { axiosApi } from '../../api/setupApi';

const useUpdateCISBohol = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateCIS = async (id, data) => {
    setIsLoading(true);
    try {
      const response = await axiosApi.put(`/cisbohol/update/${id}`, data);
      setSuccess(true);
      setError(null);
      return response.data;
    } catch (err) {
      setError(err.message || 'Failed to update CIS');
      setSuccess(false);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateCIS, isLoading, error, success };
};

export default useUpdateCISBohol;